module.exports = __webpack_public_path__ + "media/assets/services_manager/link-4fa4583b57704511fa431a873ef3f67b1f11ece61fffb8220ec72aeb9370a73f.svg";